import React from 'react';

//@ts-ignore
import HolidayGrinch from './holiday-grinch';
//@ts-ignore
import HolidayElves from './holiday-elves';
//@ts-ignore
import HolidayUi from './holiday-ui';
//@ts-ignore
import HolidayForm from './holiday-form';
// @ts-ignore
import PortalModal from './../portal-modal/./portal-modal';

interface IProps {
  snow?:any;
  characters?:any;
  colorTheme?:any;
  giveaway?:any;
  grinch?:any;
  characterCount?:any;
  site?:any;
}
interface IState {
  holidayFormModal:boolean;
}
/**
 *
 * Hero component
 * @extends {React.Component}
 */

class HolidayThemeComp extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      holidayFormModal:false
    };
  }
  public activateForm = () => {
    this.setState({
      holidayFormModal:true
    })
  }

  public hideForm = () => {
    this.setState({
      holidayFormModal:false
    })
  }
  public render(): JSX.Element {
    return(
      <span>
        {this.state.holidayFormModal &&
          <PortalModal
            modalHidden={this.hideForm}
            modalActive={this.state.holidayFormModal}
            content={
              <div className="max-width-container">
                <HolidayForm hideModal={this.hideForm} />
              </div>
            }
          />
        }
        {this.props.characters &&
          <HolidayElves
            characterCount={this.props.characterCount}
            giveaway={this.props.giveaway}
            onElfClick={this.activateForm}
            site={this.props.site}
          />
        }
        {this.props.grinch &&
          <HolidayGrinch />
        }
        <HolidayUi
          colorTheme={this.props.colorTheme}
          snow={this.props.snow}
        />
      </span>
    )
  }
}

export default HolidayThemeComp;
